export default {
  '3D_SECURE': '3dsecure',
  '3D_SECURE_UNSUCCESSFUL': '3dsecure=unsuccessful',
  SUBMITTING_ORDER: 'processing',
  POS_CREDIT: 'poscredit',
  FULL_SCREEN_SIGNUP_FLOW: 'newSignUpFlow=true',
  CREATE_ACCOUNT_CANCELLED: 'createAccountCancelled=true',
  EMAIL_VERIFICATION_ENABLED: 'x-feature-emailVerificationEnabled',
};
